export const FEATURE_FLAGS_PATH_NAME = 'feature-flags';

export const TENANT_FEATURE_FLAGS_CACHE_KEY_PREFIX = 'feature-flags';

export const AUTO_PUBLISH_FINDINGS_FLAG = 'AUTO_PUBLISH_FINDINGS';

export const TENANT_MODEL_ROUTER_ENABLED_FLAG = 'TENANT_MODEL_ROUTER_ENABLED';

export const AI_ACCOUNT_ROUTING_ENABLED_FLAG = 'AI_ACCOUNT_ROUTING_ENABLED';

export const TERRA_AI_GATEWAY_ENABLED_FLAG = 'TERRA_AI_GATEWAY_ENABLED';

export const AUTHENTICATION_DISCOVERER_ENABLED_FLAG =
  'AUTHENTICATION_DISCOVERER_ENABLED';

export const AUTHENTICATION_DISCOVERER_WIRING_ENABLED_FLAG =
  'AUTHENTICATION_DISCOVERER_WIRING_ENABLED';

export const AUTO_DISABLE_CREDENTIAL_AFTER_AUTH_FAILURES_ENABLED_FLAG =
  'AUTO_DISABLE_CREDENTIAL_AFTER_AUTH_FAILURES_ENABLED';

export const SHOULD_USE_CLAUDE_FOR_AUTH_DISCOVERY_FLAG =
  'SHOULD_USE_CLAUDE_FOR_AUTH_DISCOVERY';

export const CREDENTIAL_STORES_ENABLED_FLAG = 'CREDENTIAL_STORES_ENABLED';

export const CREDENTIALS_STORE_FILESYSTEM_ENABLED_FLAG =
  'CREDENTIALS_STORE_FILESYSTEM_ENABLED';

export const AUTHENTICATION_COOLDOWN_ENABLED_FLAG =
  'AUTHENTICATION_COOLDOWN_ENABLED';

export const AUTHENTICATION_PREFLIGHT_ENABLED_FLAG =
  'AUTHENTICATION_PREFLIGHT_ENABLED';

export const NEO_PYTHON_TOOL_ENABLED_FLAG = 'NEO_PYTHON_TOOL_ENABLED';

export const NEO_ATTACK_LEARNINGS_ANALYZER_ENABLED_FLAG =
  'NEO_ATTACK_LEARNINGS_ANALYZER_ENABLED';

export const NEO_ASK_CODE_BASE_WIDE_SEARCH_ENABLED_FLAG =
  'NEO_ASK_CODE_BASE_WIDE_SEARCH_ENABLED';

export const ASK_CODE_BASE_TOOL_ENABLED_FLAG = 'ASK_CODE_BASE_TOOL_ENABLED';

export const CVSS_CODEBASE_TOOL_ENABLED_FLAG = 'CVSS_CODEBASE_TOOL_ENABLED';

export const FINDING_CVSS_DETAILS_TAB_ENABLED_FLAG =
  'FINDING_CVSS_DETAILS_TAB_ENABLED';

export const NEO_NAVIGATE_WEB_SESSION_INJECTION_ENABLED_FLAG =
  'NEO_NAVIGATE_WEB_SESSION_INJECTION_ENABLED';

export const NEO_BROWSER_SESSION_TOOLS_ENABLED_FLAG =
  'NEO_BROWSER_SESSION_TOOLS_ENABLED';

export const NEO_GENERIC_WORKER_ENABLED_FLAG = 'NEO_GENERIC_WORKER_ENABLED';

export const NEO_BROWSER_SESSION_AUTH_ENABLED_FLAG =
  'NEO_BROWSER_SESSION_AUTH_ENABLED';

export const NEO_POST_ATTACK_CONTEXT_VERIFICATION_ENABLED_FLAG =
  'NEO_POST_ATTACK_CONTEXT_VERIFICATION_ENABLED';

export const CREDENTIAL_LOGIN_LEASE_ENFORCEMENT_ENABLED_FLAG =
  'CREDENTIAL_LOGIN_LEASE_ENFORCEMENT_ENABLED';

export const CREDENTIAL_LOGIN_SESSION_VERIFICATION_ENABLED_FLAG =
  'CREDENTIAL_LOGIN_SESSION_VERIFICATION_ENABLED';

export const CREDENTIAL_LOGIN_SESSION_CONTINUITY_ENABLED_FLAG =
  'CREDENTIAL_LOGIN_SESSION_CONTINUITY_ENABLED';

export const CRAWLER_SKIP_FAILED_VERIFICATION_CREDENTIALS_ENABLED_FLAG =
  'CRAWLER_SKIP_FAILED_VERIFICATION_CREDENTIALS_ENABLED';

export const CRAWLER_STORED_LOGIN_ENABLED_FLAG = 'CRAWLER_STORED_LOGIN_ENABLED';

export const NEO_RUN_LOGIN_ENABLED_FLAG = 'NEO_RUN_LOGIN_ENABLED';

export const MFA_CODE_PLACEHOLDER_TYPING_ENABLED_FLAG =
  'MFA_CODE_PLACEHOLDER_TYPING_ENABLED';

export const NEO_BROWSER_DISABLED_FLAG = 'NEO_BROWSER_DISABLED';

export const DEEP_ACTIVE_PROBE_BROWSER_DISABLED_FLAG =
  'DEEP_ACTIVE_PROBE_BROWSER_DISABLED';

export const DEEP_ACTIVE_PROBE_ENABLED_FLAG = 'DEEP_ACTIVE_PROBE_ENABLED';

export const DEEP_CANDIDATE_PROBE_ENABLED_FLAG = 'DEEP_CANDIDATE_PROBE_ENABLED';

export const AGGREGATE_HTTP_AUTH_COOKIES_ENABLED_FLAG =
  'AGGREGATE_HTTP_AUTH_COOKIES_ENABLED';

export const AUTHENTICATOR_HTTP_ONLY_ENABLED_FLAG =
  'AUTHENTICATOR_HTTP_ONLY_ENABLED';

export const AUTHENTICATOR_RECURSION_LIMIT_FLAG =
  'AUTHENTICATOR_RECURSION_LIMIT';

export const DEFAULT_AUTHENTICATOR_RECURSION_LIMIT = 25;

export const AUTH_PROBE_ENABLED_FLAG = 'AUTH_PROBE_ENABLED';

export const AI_BROWSER_EXTERNAL_API_PROXY_ENABLED_FLAG =
  'AI_BROWSER_EXTERNAL_API_PROXY_ENABLED';

export const PROXY_OVERRIDE_BASIC_AUTHORIZATION_ENABLED_FLAG =
  'PROXY_OVERRIDE_BASIC_AUTHORIZATION_ENABLED';

export const PROBE_HTTP_CREDENTIAL_AUTO_APPLY_DISABLED_FLAG =
  'PROBE_HTTP_CREDENTIAL_AUTO_APPLY_DISABLED';

export const DYNAMIC_APPLICATION_SCAN_AUTOMATION_ENABLED_FLAG =
  'DYNAMIC_APPLICATION_SCAN_AUTOMATION_ENABLED';

export const NOVA_SCAN_PRIORITY_FLAG = 'NOVA_SCAN_PRIORITY';

export const NOVA_SCAN_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH'] as const;

export type NovaScanPriority = (typeof NOVA_SCAN_PRIORITIES)[number];

export const DEFAULT_NOVA_SCAN_PRIORITY: NovaScanPriority = 'MEDIUM';

export const NOVA_SCAN_CAP_BY_PRIORITY: Record<NovaScanPriority, number> = {
  LOW: 5,
  MEDIUM: 20,
  HIGH: 50,
};

export const ADAPTIVE_SCANNING_ENABLED_FLAG = 'ADAPTIVE_SCANNING_ENABLED';

export const DEFER_AUTO_ATTACK_UNTIL_DISCOVERY_IDLE_FLAG =
  'DEFER_AUTO_ATTACK_UNTIL_DISCOVERY_IDLE';

export const SIGNAL_IMPORT_ENABLED_FLAG = 'SIGNAL_IMPORT_ENABLED';

export const SECURITY_TEST_CASE_COMBINED_DUAL_INVOCATION_ENABLED_FLAG =
  'SECURITY_TEST_CASE_COMBINED_DUAL_INVOCATION_ENABLED';

export const SECURITY_TEST_CASE_DEPLOYMENT_SKILL_ENABLED_FLAG =
  'SECURITY_TEST_CASE_DEPLOYMENT_SKILL_ENABLED';

export const SECURITY_TEST_CASE_AVAILABILITY_SKILL_ENABLED_FLAG =
  'SECURITY_TEST_CASE_AVAILABILITY_SKILL_ENABLED';

export const SECURITY_TEST_CASE_BUSINESS_CONTEXT_TOOLS_ENABLED_FLAG =
  'SECURITY_TEST_CASE_BUSINESS_CONTEXT_TOOLS_ENABLED';

export const DEEP_SECURITY_TEST_CASE_SCAN_ENABLED_FLAG =
  'DEEP_SECURITY_TEST_CASE_SCAN_ENABLED';

export const SIGNAL_GENERATION_ATTRIBUTION_ENABLED_FLAG =
  'SIGNAL_GENERATION_ATTRIBUTION_ENABLED';

export const INFORMATION_DISCLOSURE_SIGNALS_ENABLED_FLAG =
  'INFORMATION_DISCLOSURE_SIGNALS_ENABLED';

export const MISCONFIG_ENDPOINT_AUTO_SIGNALS_ENABLED =
  'MISCONFIG_ENDPOINT_AUTO_SIGNALS_ENABLED';

export const MISCONFIG_TECH_STACK_SIGNALS_ENABLED =
  'MISCONFIG_TECH_STACK_SIGNALS_ENABLED';

export const SIGNALS_PAGE_ENABLED_FLAG = 'SIGNALS_PAGE_ENABLED';

export const ALL_SIGNALS_PAGE_ENABLED_FLAG = 'ALL_SIGNALS_PAGE_ENABLED';

export const JIRA_CONFIGURATION_PROFILES_UI_ENABLED_FLAG =
  'JIRA_CONFIGURATION_PROFILES_UI_ENABLED';

export const SIGNAL_IMPORT_PROBE_CONTEXT_TOOL_ENABLED_FLAG =
  'SIGNAL_IMPORT_PROBE_CONTEXT_TOOL_ENABLED';

export const SIGNAL_IMPORT_REPROCESS_UNCHANGED_ENABLED_FLAG =
  'SIGNAL_IMPORT_REPROCESS_UNCHANGED_ENABLED';

export const ASSET_MERGE_ENABLED_FLAG = 'ASSET_MERGE_ENABLED';

export const ENDPOINT_HAR_REASSOCIATE = 'ENDPOINT_HAR_REASSOCIATE';

export const FEATURE_ANALYSIS_CREDENTIAL_REMOVAL_ENABLED_FLAG =
  'FEATURE_ANALYSIS_CREDENTIAL_REMOVAL_ENABLED';

export const LIVE_BROWSER_WORKSPACE_ENABLED_FLAG =
  'LIVE_BROWSER_WORKSPACE_ENABLED';

export const BROWSER_SESSION_KUBERNETES_DRIVER_ENABLED_FLAG =
  'BROWSER_SESSION_KUBERNETES_DRIVER_ENABLED';

export const BROWSER_SESSION_INDEXED_DB_ENABLED_FLAG =
  'BROWSER_SESSION_INDEXED_DB_ENABLED';

export const SCHEDULED_ASSET_DEDUP_FLAG = 'SCHEDULED_ASSET_DEDUP';

export const POST_BATCH_URL_PARAMETRIZATION_ASSET_DEDUP_FLAG =
  'POST_BATCH_URL_PARAMETRIZATION_ASSET_DEDUP';

export const ARCHIVED_ASSETS_LIFECYCLE_ENABLED_FLAG =
  'ARCHIVED_ASSETS_LIFECYCLE_ENABLED';

export const UNVERIFIED_ASSETS_ALL_STATUSES_SHOWN_FLAG =
  'UNVERIFIED_ASSETS_ALL_STATUSES_SHOWN';

export const PROBE_DEFERRAL_FLUSH_MIN_CREATED_AT_DEFAULT_MS = Date.UTC(
  2026,
  7,
  5,
);

export const KATANA_PER_CREDENTIAL_DISPATCH_ENABLED_AT_MS_FLAG =
  'KATANA_PER_CREDENTIAL_DISPATCH_ENABLED_AT_MS';

export const KATANA_PER_CREDENTIAL_DISPATCH_ENABLED_AT_DEFAULT_MS = Date.UTC(
  2026,
  8,
  29,
);

export const WEBSOCKET_HAR_MAX_MESSAGE_SAMPLES_FLAG =
  'WEBSOCKET_HAR_MAX_MESSAGE_SAMPLES';

export const WEBSOCKET_TRACKING_ENABLED_FLAG = 'WEBSOCKET_TRACKING_ENABLED';

export const GRPC_WEB_SUPPORT_ENABLED_FLAG = 'GRPC_WEB_SUPPORT_ENABLED';

export const AIRFLOW_FASTAPI_PLUGIN_ROUTE_HINTS_ENABLED_FLAG =
  'AIRFLOW_FASTAPI_PLUGIN_ROUTE_HINTS_ENABLED' as const;

export const PROTO_COLLECTION_MAX_FILE_COUNT_FLAG =
  'PROTO_COLLECTION_MAX_FILE_COUNT';

export const DEFAULT_PROTO_COLLECTION_MAX_FILE_COUNT = 200;

export const PROTO_COLLECTION_MAX_FILE_COUNT_CEILING = 5_000;

export const SKIP_NOISE_URL_EXTENSIONS_FLAG = 'SKIP_NOISE_URL_EXTENSIONS';

export const WEB_DISCOVERY_LIMIT_SCALE_FLAG = 'WEB_DISCOVERY_LIMIT_SCALE';

export const DEFAULT_WEB_DISCOVERY_LIMIT_SCALE = 1;

export const AI_CAPACITY_LICENSE_ENABLED_FLAG = 'AI_CAPACITY_LICENSE_ENABLED';

export const AI_CAPACITY_MARKUP_PERCENT_FLAG = 'AI_CAPACITY_MARKUP_PERCENT';

export const COPILOT_DOCS_SEARCH_TOOL_ENABLED_FLAG =
  'COPILOT_DOCS_SEARCH_TOOL_ENABLED';

export const COPILOT_EXTENDED_PROMPT_CACHE_TTL_ENABLED_FLAG =
  'COPILOT_EXTENDED_PROMPT_CACHE_TTL_ENABLED';

export const COPILOT_DEFERRED_TOOL_LOADING_ENABLED_FLAG =
  'COPILOT_DEFERRED_TOOL_LOADING_ENABLED';

export const COPILOT_TOOL_RESULT_BUDGET_ENABLED_FLAG =
  'COPILOT_TOOL_RESULT_BUDGET_ENABLED';

export const COPILOT_ACTION_AUTO_REVIEW_ENABLED_FLAG =
  'COPILOT_ACTION_AUTO_REVIEW_ENABLED';

export const MCP_SERVERS_ENABLED_FLAG = 'MCP_SERVERS_ENABLED';

export const COPY_WEB_APPLICATION_TO_AI_ENABLED_FLAG =
  'COPY_WEB_APPLICATION_TO_AI_ENABLED';

export const UNIFIED_WEB_AI_APPLICATIONS_ENABLED_FLAG =
  'UNIFIED_WEB_AI_APPLICATIONS_ENABLED';

export const NUCLEI_TEMPLATE_TOOLS_ENABLED_FLAG =
  'NUCLEI_TEMPLATE_TOOLS_ENABLED';

export const CODE_CHANGES_PROCESSED_PR_LIST_ENABLED_FLAG =
  'CODE_CHANGES_PROCESSED_PR_LIST_ENABLED';

export const REPOSITORY_RELEVANCE_CATALOG_ENABLED =
  'REPOSITORY_RELEVANCE_CATALOG_ENABLED';

export const REPOSITORY_EXPANSION_CAP_FLAG = 'REPOSITORY_EXPANSION_CAP';

export const DEFAULT_REPOSITORY_EXPANSION_CAP = 20;

export const REPOSITORY_CATALOG_CLONE_ALL_FALLBACK_ENABLED =
  'REPOSITORY_CATALOG_CLONE_ALL_FALLBACK_ENABLED';

export const REPOSITORY_CATALOG_MIN_CONNECTED_REPOSITORIES_FLAG =
  'REPOSITORY_CATALOG_MIN_CONNECTED_REPOSITORIES';

export const DEFAULT_REPOSITORY_CATALOG_MIN_CONNECTED_REPOSITORIES = 20;

export const SOURCE_CODE_UPLOAD_MAX_FILES_PER_BATCH_FLAG =
  'SOURCE_CODE_UPLOAD_MAX_FILES_PER_BATCH';

export const DEFAULT_SOURCE_CODE_UPLOAD_MAX_FILES_PER_BATCH = 200;

export const INGEST_TARGET_BRANCH_COMMITS_AS_PRS_ENABLED =
  'INGEST_TARGET_BRANCH_COMMITS_AS_PRS_ENABLED';

export const DEFAULT_WEBSOCKET_HAR_MAX_MESSAGE_SAMPLES = 50;

export const CODE_EXECUTION_KUBERNETES_DRIVER_ENABLED_FLAG =
  'CODE_EXECUTION_KUBERNETES_DRIVER_ENABLED';

export const SCAN_JOB_KUBERNETES_DRIVER_ENABLED_FLAG =
  'SCAN_JOB_KUBERNETES_DRIVER_ENABLED';

export const BEDROCK_SDK_MAX_ATTEMPTS_FLAG = 'BEDROCK_SDK_MAX_ATTEMPTS';

export const DEFAULT_BEDROCK_SDK_MAX_ATTEMPTS = 1;

export const MAX_BEDROCK_SDK_MAX_ATTEMPTS = 5;

export const COMPOUNDING_PATH_MIN_REPEATS_FLAG = 'COMPOUNDING_PATH_MIN_REPEATS';

export const ENDPOINT_DISCOVERY_CLAUDE_BG_WAIT_CEILING_MS_FLAG =
  'ENDPOINT_DISCOVERY_CLAUDE_BG_WAIT_CEILING_MS';

export const EXTERNAL_NETWORK_ATTACK_SKIP_TARGET_REACHABILITY_CHECK_FLAG =
  'EXTERNAL_NETWORK_ATTACK_SKIP_TARGET_REACHABILITY_CHECK';

export const CLAUDE_SESSION_S3_STORE_ENABLED_FLAG =
  'CLAUDE_SESSION_S3_STORE_ENABLED';

export const DEFAULT_ENDPOINT_DISCOVERY_CLAUDE_BG_WAIT_CEILING_MS =
  60 * 60 * 1000;

export const CLIENT_BUNDLE_SCAN_ENABLED_FLAG = 'CLIENT_BUNDLE_SCAN_ENABLED';

export const BROWSER_HTTP_CACHE_ENABLED_FLAG = 'BROWSER_HTTP_CACHE_ENABLED';

export const BROWSER_CONTEXT_IDLE_HOLD_ENABLED_FLAG =
  'BROWSER_CONTEXT_IDLE_HOLD_ENABLED';

export const CLIENT_BUNDLE_SCAN_SECRETS_ENABLED_FLAG =
  'CLIENT_BUNDLE_SCAN_SECRETS_ENABLED';

export const CLIENT_BUNDLE_SCAN_SCA_ENABLED_FLAG =
  'CLIENT_BUNDLE_SCAN_SCA_ENABLED';

export const CLIENT_BUNDLE_SCAN_SAST_ENABLED_FLAG =
  'CLIENT_BUNDLE_SCAN_SAST_ENABLED';

export const CLIENT_BUNDLE_SCAN_NEO_VALIDATION_ENABLED_FLAG =
  'CLIENT_BUNDLE_SCAN_NEO_VALIDATION_ENABLED';

export const ILI_PASSIVE_INTEL_ENABLED_FLAG = 'ILI_PASSIVE_INTEL_ENABLED';

export const IP_ALLOWLIST_ENABLED_FLAG = 'IP_ALLOWLIST_ENABLED';

export const TORCH_TENANT_LICENSE_FILTER_ENABLED_FLAG =
  'TORCH_TENANT_LICENSE_FILTER_ENABLED';

export const OWNED_MEMORY_DUAL_WRITE_ENABLED_FLAG =
  'OWNED_MEMORY_DUAL_WRITE_ENABLED' as const;

export const OWNED_MEMORY_READS_ENABLED_FLAG =
  'OWNED_MEMORY_READS_ENABLED' as const;

export type FeatureFlagValue = boolean | number | string | null;

export const FEATURE_FLAG_SUPPORTED_TARGET_TYPES = {
  TENANT: 'tenant',
  APPLICATION: 'application',
  USER: 'user',
  SEGMENT: 'segment',
} as const;

export type FeatureFlagSupportedTargetType =
  (typeof FEATURE_FLAG_SUPPORTED_TARGET_TYPES)[keyof typeof FEATURE_FLAG_SUPPORTED_TARGET_TYPES];

export const DEFAULT_FEATURE_FLAG_SUPPORTED_TARGET_TYPES = [
  FEATURE_FLAG_SUPPORTED_TARGET_TYPES.TENANT,
] as const;

export const FEATURE_FLAG_TYPES = {
  BOOLEAN: 'BOOLEAN',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  TIMESTAMP: 'TIMESTAMP',
} as const;

export type FeatureFlagType =
  (typeof FEATURE_FLAG_TYPES)[keyof typeof FEATURE_FLAG_TYPES];

export type FeatureFlagDefinitionEntryInput = {
  readonly name: string;
  readonly type: FeatureFlagType;
  readonly defaultValue: FeatureFlagValue;
  readonly supportedTargetTypes?: readonly FeatureFlagSupportedTargetType[];
};
